import { render, staticRenderFns } from "./SerpDialogDetailTable.vue?vue&type=template&id=61fddf6b&"
import script from "./SerpDialogDetailTable.vue?vue&type=script&lang=js&"
export * from "./SerpDialogDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./SerpDialogDetailTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SerpDialogDetailTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSimpleTable,VSkeletonLoader})
